/** Segments de 1er niveau (sans locale) nécessitant une session. */
export const PRIVATE_ROUTE_SEGMENTS: ReadonlySet<string> = new Set([
  'discuter',
  'mon-compte',
  'onboarding',
])
